// Scene identity constants. The scene components import these and the shell
// uses identity comparison to map id → component. Strings (not the components
// themselves) so this helper has zero runtime dependencies and is trivial to
// unit-test.
export const SCENE_MARKSMAN = 'marksman';
export const SCENE_VET_DOG = 'vetDog';
export const SCENE_RUNNER = 'runner';
export const SCENE_MUSHING = 'mushing';
export const SCENE_PAPER_PLANE = 'paperPlane';

// Precedence is intentional: a club that enables more than one menu area
// (e.g. shootingTools + dyrejournal) still gets exactly one scene. The first
// match wins. Update this list — not the call sites — to change priority.
export default function pickScene(currentCustomer) {
    const menuItems = (currentCustomer && currentCustomer.menuItems) || {};
    if (menuItems.shootingTools) return SCENE_MARKSMAN;
    if (menuItems.dyrejournal) return SCENE_VET_DOG;
    if (menuItems.liverace) return SCENE_MUSHING;
    return SCENE_PAPER_PLANE;
}
